import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import CheckBoxRadioButtonInput from 'components/ui/forms/field/checkbox-radiobutton/CheckBoxRadioButtonInput'
import { BlockIcon } from 'components/BlockIcon'
import { BlockTypes } from 'enum'
import styles from './DefaultLevel.module.scss'

export interface IDefaultLevel {
  id: number
  name: string
  type: BlockTypes
  onCheck: any
  checked: any[]
}

const DefaultLevel: React.FC<IDefaultLevel> = ({
  id,
  type,
  name,
  onCheck,
  checked,
}) => {
  const { t } = useTranslation()
  const isChecked = useMemo(
    () => (checked && checked.length >= 0 ? checked.includes(id) : false),
    [checked, id]
  )

  return (
    <div>
      <a className={styles.container}>
        <div className={'blockNameContainer'}>
          <CheckBoxRadioButtonInput
            name={'block' + id}
            value={false}
            label=""
            inline={false}
            type="checkbox"
            onChange={() => onCheck(id)}
            checked={isChecked}
            customLabel={
              <>
                <BlockIcon type={type} />
                <span className={styles.blockName}>
                  {name.trim() === ''
                    ? `[${t('administration.courses.duplicate.noNameBlock')}]`
                    : name}
                </span>
              </>
            }
          ></CheckBoxRadioButtonInput>
        </div>
      </a>
    </div>
  )
}

export default DefaultLevel
